import { render } from "./OptionsSocials.vue?vue&type=template&id=6f94fb96"
import script from "./OptionsSocials.vue?vue&type=script&lang=js"
export * from "./OptionsSocials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__